import NewPasswordForm from './NewPasswordForm'
import enhance from './NewPasswordForm.enhancer'

export default enhance(NewPasswordForm)



// WEBPACK FOOTER //
// ./src/components/organisms/NewPasswordForm/index.js